__turbopack_context__.v({
  "banner": "LK8Qvq_banner",
  "bannerBody": "LK8Qvq_bannerBody",
  "bannerWrapper": "LK8Qvq_bannerWrapper",
});
